import { StoreId } from "@ubnt/store.core/lib/types";
import { UI_COM_SITE_CONFIG } from "context/SiteSettingsContext/constants";
import { match, useRouteMatch } from "react-router";

const prepareArrayForPath = (arr: string[]): string =>
  arr.map((el) => el.toLowerCase()).join("|");

// We are enabling all StoreId's - consider adjusting the CF functions
export const REGIONAL_MICROSITE_PREFIX_PATH = `/:storeId(${prepareArrayForPath(
  Object.values(StoreId),
)})`;

export const LANGUAGE_PATH = `/:language(${prepareArrayForPath(
  UI_COM_SITE_CONFIG.defaultRegion.languages,
)})`;

/**
 * Patterns that indicate new a.k.a "regional" designs
 */
export const newNewDesignPaths = [
  `${REGIONAL_MICROSITE_PREFIX_PATH}/`,
  `${REGIONAL_MICROSITE_PREFIX_PATH}/:page/`,
  // Kinda redundant, but leaving for documentation
  `${REGIONAL_MICROSITE_PREFIX_PATH}${LANGUAGE_PATH}/:page/`,
];

/**
 * @returns {{ params: any } | undefined}
 */
export const useMatchNewDesignRoute = (): match<Record<string, string>> => {
  /**
   * Detect pattern of "new-design" routes and try to find a route we have defined and derive a basic boolean from it as
   * it returns the "react-router-dom" route configuration object for the matching route
   */
  const matchingNewDesignRouteDefinition = useRouteMatch(newNewDesignPaths);
  
  return matchingNewDesignRouteDefinition;
};
